
/* Kesser theme — product page fixes: variant<->gallery sync, disabled option combos, sticky mobile ATC.
   Also handles the generic gallery-thumb click (moved here from theme.js to avoid double-binding). */
(function () {
  'use strict';
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2).replace('.', ',');
    var parts = value.split(',');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return 'R$ ' + parts.join(',');
  }

  /* ---------------- Product gallery thumbs (manual click) ---------------- */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-gallery-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('[data-product-gallery]');
    var mainImg = qs('[data-product-main-image]', gallery);
    if (mainImg) mainImg.src = thumb.getAttribute('data-full-src');
    qsa('[data-gallery-thumb]', gallery).forEach(function (t) { t.setAttribute('aria-current', 'false'); });
    thumb.setAttribute('aria-current', 'true');
  });

  qsa('[data-product-root]').forEach(function (root) {
    var productJsonEl = qs('[data-product-json]', root);
    if (!productJsonEl) return;
    var product = JSON.parse(productJsonEl.textContent);
    var form = qs('[data-product-form]', root);
    var gallery = qs('[data-product-gallery]', root);
    var mainImageWrap = qs('.product-gallery__main', gallery);
    var mainImg = qs('[data-product-main-image]', gallery);
    var priceEl = qs('[data-product-price]', root);
    /* Products with real options (has_only_default_variant: false) start with no swatch
       selected, so the shopper must choose one in every option group before a variant can
       be resolved — see getSelectedOptions()/updateForVariant() below. */
    var hasOptionPicker = product.variants.length > 1;
    var variantTitles = null;
    try { variantTitles = root.getAttribute('data-variant-titles') ? JSON.parse(root.getAttribute('data-variant-titles')) : null; } catch (e) {}

    function findVariant(options) {
      /* Products with no real options (has_only_default_variant) render no
         option inputs at all, so getSelectedOptions() always returns [] for
         them. Matching v.options.every(...) against an empty array can never
         succeed (there's always at least a "Default Title" entry to compare),
         so this used to always fail to find the variant — disabling "add to
         cart" and showing "Indisponível" even with real stock. With a single
         variant there's nothing to disambiguate anyway, so just return it. */
      if (product.variants.length === 1) return product.variants[0];
      return product.variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === options[i]; });
      });
    }

    function getSelectedOptions() {
      if (!form) return [];
      return qsa('input[name^="option-"]:checked, select[name^="option-"]', form)
        .sort(function (a, b) {
          return parseInt(a.name.split('-')[1], 10) - parseInt(b.name.split('-')[1], 10);
        })
        .map(function (el) { return el.value; });
    }

    function setMainImage(src) {
      if (!mainImg || !src || mainImg.src === src) return;
      if (mainImageWrap) mainImageWrap.classList.add('is-loading');
      var probe = new Image();
      probe.onload = function () {
        mainImg.src = src;
        if (mainImageWrap) mainImageWrap.classList.remove('is-loading');
      };
      probe.src = src;
    }

    function syncThumbActive(src) {
      qsa('[data-gallery-thumb]', gallery).forEach(function (t) {
        t.setAttribute('aria-current', t.getAttribute('data-full-src') === src ? 'true' : 'false');
      });
    }

    function updateForVariant() {
      if (!form) return;
      var options = getSelectedOptions();
      /* Only attempt to resolve a variant once every option group has a selection.
         Single-variant products (hasOptionPicker === false) have no groups to wait on. */
      var allOptionsChosen = !hasOptionPicker || options.length === product.options.length;
      var variant = allOptionsChosen ? findVariant(options) : null;
      var idInput = qs('input[name="id"]', form);
      var submitBtn = qs('[data-add-to-cart-btn]', form);

      qsa('.swatch', form).forEach(function (label) {
        var input = qs('input', label);
        if (!input) return;
        var testOptions = options.slice();
        var idx = parseInt(input.name.split('-')[1], 10);
        testOptions[idx] = input.value;
        var testVariant = findVariant(testOptions);
        input.disabled = !testVariant || !testVariant.available;
      });

      if (variant) {
        if (idInput) idInput.value = variant.id;
        if (priceEl) {
          var html = '';
          if (variant.compare_at_price > variant.price) {
            html += '<s>' + formatMoney(variant.compare_at_price) + '</s> ';
          }
          html += formatMoney(variant.price);
          priceEl.innerHTML = html;
        }
        var stickyPrice = qs('[data-sticky-atc-price]');
        if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
        var inst = qs('[data-product-installments]', root);
        if (inst) {
          var instTxt = inst.textContent.replace(/4x de .*? sem juros/, '4x de ' + formatMoney(Math.floor(variant.price / 4)) + ' sem juros');
          inst.textContent = instTxt;
        }
        if (variantTitles) {
          var vtitle = variantTitles[String(variant.id)];
          if (vtitle) {
            var h1 = qs('[data-product-title]', root);
            if (h1) h1.textContent = vtitle;
            var stTitle = qs('[data-sticky-atc-title]');
            if (stTitle) stTitle.textContent = vtitle;
          }
        }
        var stickyVariant = qs('[data-sticky-atc-variant]');
        if (stickyVariant) {
          var vt = variant.title && variant.title !== 'Default Title' ? variant.title : '';
          stickyVariant.textContent = vt;
          stickyVariant.hidden = !vt;
        }
        if (submitBtn) {
          submitBtn.disabled = !variant.available;
          submitBtn.textContent = variant.available
            ? (window.themeStrings.addToCart || 'Adicionar à sacola')
            : (window.themeStrings.soldOut || 'Esgotado');
        }
        if (variant.featured_image) {
          var src = variant.featured_image.src || (variant.featured_image.preview_image && variant.featured_image.preview_image.src);
          if (src) {
            var fullSrc = src.indexOf('width=') > -1 ? src : src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=1000';
            setMainImage(fullSrc);
            syncThumbActive(fullSrc);
          }
        }
      } else if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = hasOptionPicker && !allOptionsChosen
          ? (window.themeStrings.chooseOptions || 'Escolher opções')
          : (window.themeStrings.unavailable || 'Indisponível');
      }
    }

    if (form) {
      /* Browsers (notably iOS Safari) restore previously checked radios on reload/back, which
         overrode the server-rendered selection (e.g. preselected 10 pares). Reset to the markup. */
      qsa('input[name^="option-"]', form).forEach(function (el) { el.checked = el.defaultChecked; });
      form.setAttribute('autocomplete', 'off');
      window.addEventListener('pageshow', function (ev) {
        if (!ev.persisted) return;
        qsa('input[name^="option-"]', form).forEach(function (el) { el.checked = el.defaultChecked; });
        updateForVariant();
      });
      form.addEventListener('change', function (e) {
        if (e.target.name && e.target.name.indexOf('option-') === 0) updateForVariant();
      });
      updateForVariant();
    }
  });

  /* Sticky mobile add-to-cart bar: mirrors the in-page form's submit + shows once the real button scrolls out of view */
  var stickyBar = qs('[data-sticky-atc]');
  var realForm = qs('[data-product-form]');
  var realBtn = realForm ? qs('[data-add-to-cart-btn]', realForm) : null;

  if (stickyBar && realBtn && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyBar.hidden = entry.isIntersecting;
        stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    observer.observe(realBtn);

    var stickyBtn = qs('[data-sticky-atc-btn]', stickyBar);
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        if (realForm) realForm.requestSubmit ? realForm.requestSubmit() : realBtn.click();
      });
    }
  }
})();
